// removed by extract-text-webpack-plugin
module.exports = {"modal":"_9QpxUHsL3vkwTkjwoGLBl","mask":"_2dRezGpzu61ieyYHxe3T_c","button":"_2aEMFtVDRsXvxcb4K8IEs0","cancelButton":"_2pa9fCfzjcldP-jRlR8YDo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.scss
// module id = 919
// module chunks = 0